import { render, staticRenderFns } from "./ContactIndividualForm.vue?vue&type=template&id=65101434"
import script from "./ContactIndividualForm.vue?vue&type=script&lang=ts"
export * from "./ContactIndividualForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports